module.exports = __webpack_public_path__ + "static/tat-4-14eee751b5923c746e9a5e23a2bb613c.jpg";